import activitiesTabRedux from 'Modules/activities/.components/tab/redux/reducer';
import activitiesMainRedux from 'Modules/activities/views/main/redux/reducer';
import changeDetailsRedux from 'Modules/activities/.components/changeDetails/redux/reducer';
import generalDetailsRedux from 'Modules/activities/.components/generalDetails/redux/reducer';
import changeListRedux from 'Modules/activities/.components/changeList/redux/reducer';

//export redux objects
export default {
    activitiesTabRedux,
    activitiesMainRedux,
    changeDetailsRedux,
    generalDetailsRedux,
    changeListRedux,
};